
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSetAssembleDtDialog extends Serenity.Extensions.GridEditorDialog<IcStockSetAssembleDtRow> {
        protected getFormKey() { return IcStockSetAssembleDtForm.formKey; }
        // protected getIdProperty() { return IcStockSetAssembleDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockSetAssembleDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockSetAssembleDtRow.nameProperty; }
        // protected getService() { return IcStockSetAssembleDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockSetAssembleDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockSetAssembleDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockSetAssembleDtRow.updatePermission; }

        protected form = new IcStockSetAssembleDtForm(this.idPrefix);

    }
}